import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useUser from '@alltrails/context/hooks/useUser';
import logError from '@alltrails/core/utils/logError';
import Button from '@alltrails/denali/components/Button';
import type { Track } from '@alltrails/types/Track';
import styles from './ActivitiesList.module.scss';
import getActivities from './api';
import LoadingActivitesList from './LoadingActivitiesList';

const TrackCard = dynamic(() => import('../TrackCard'), { ssr: false });

const ActivitiesList = ({ trailId, totalActivities }) => {
  const intl = useIntl();
  const user = useUser();
  const [activities, setActivities] = useState<Track[]>([]);
  const [page, setPage] = useState(0);

  useEffect(() => {
    getActivities(trailId, page)
      .then((response: any) => {
        const newActivities = response.maps;
        setActivities([...activities, ...newActivities]);
      })
      .catch(error => {
        logError(new Error(`Error when getting activities for trailId: ${trailId}: ${error.message}`));
      });
  }, [page, trailId]);

  if (!activities.length) {
    return <LoadingActivitesList />;
  }

  const onTrackDeleted = (id: number) => {
    setActivities(prevActivities => prevActivities.filter(activity => activity.id !== id));
  };

  return (
    <div>
      <div className={styles.heading}>
        {intl.formatMessage({ defaultMessage: '{activityCount, plural, one {# activity} other {# activities}}' }, { activityCount: totalActivities })}
      </div>
      {activities.map(track => (
        <TrackCard key={track.id} track={track} userId={user?.id} trailId={trailId} onTrackDeleted={onTrackDeleted} />
      ))}
      {activities.length < totalActivities && (
        <Button onClick={() => setPage(page + 1)} text={<FormattedMessage defaultMessage="Show more" />} variant="default" />
      )}
    </div>
  );
};

export default ActivitiesList;
